import React from "react";
import "./OrderSuccessModal.css";

const OrderSuccessModal = ({ email, onClose }) => {
    return (
        <div className="order-success-backdrop" onClick={onClose}>
            <div className="order-success-modal" onClick={(e) => e.stopPropagation()}>
                <div className="order-success-modal__header">
                    <h3 className="order-success-modal__title">Order Placed</h3>
                </div>
                <div className="order-success-modal__body">
                    <div className="order-success-modal__icon">✓</div>
                    <p className="order-success-modal__message">
                        You should receive an email at <strong>{email}</strong> with your chain of
                        custody form. Print the sheet in landscape and include with your samples
                        when shipping your product. If it doesn't arrive, you can download the
                        form at any time from your order on the Lab Orders page.
                    </p>
                </div>
                <div className="order-success-modal__footer">
                    <button className="order-success-modal__btn" onClick={onClose}>
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderSuccessModal;
